import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';

import classnames from 'classnames';
import Html from 'components/Html';
import Icon from 'components/icons';
import { I18n, translate } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import PropTypes from 'prop-types';

import marketingBannerImage from '../../assets/marketing-banner-image.svg';
import DashboardEvents from '../../DashboardEvents';

import './MarketingBanner.scss';

class MarketingBanner extends PureComponent {
  static propTypes = {
    t: PropTypes.func,
    className: PropTypes.string,
    marketplaceId: PropTypes.number,
    history: PropTypes.object
  };

  steps = ['content', 'ads', 'publish'];

  get classes() {
    return classnames('marketing_banner', this.props.className);
  }

  handleClick = () => {
    const { marketplaceId } = this.props;

    DashboardEvents.clickOnMarketingBanner(marketplaceId);

    this.redirectToContent();
  };

  redirectToContent = () => {
    const { history } = this.props;

    history.push(ROUTES.CONTENT.LIST);
  };

  renderStep = (step, key) => {
    const { t } = this.props;
    const label = `dashboard.banner_marketing.steps.${step}`;

    return (
      <div
        className="marketing_banner__steps__item"
        data-test="banner-steps"
        key={label}
      >
        <span className="marketing_banner__steps__item_number">{++key}</span>
        <Html className="marketing_banner__steps__item_text">{t(label)}</Html>
      </div>
    );
  };

  render() {
    return (
      <div data-test="banner-container" className={this.classes}>
        <header className="marketing_banner__title" data-test="banner-title">
          <I18n label="dashboard.banner_marketing.title_v2" />
        </header>
        <p
          className="marketing_banner__description"
          data-test="banner-description"
        >
          <I18n label="dashboard.banner_marketing.description_v2" />
        </p>
        <div className="marketing_banner__bg">
          <img
            className="marketing_banner__bg__img"
            src={marketingBannerImage}
            alt=""
          />
        </div>
        <div className="marketing_banner__steps">
          {this.steps.map(this.renderStep)}
        </div>
        <footer className="marketing_banner__footer">
          <button
            className="hot-button hot-button--tertiary marketing_banner__footer__button"
            data-test="start-now-button"
            onClick={this.handleClick}
          >
            <I18n label="dashboard.navigation_card.club_sales.action" />
            <Icon prefix="fal" iconName="arrow-right" className="_ml-2" />
          </button>
        </footer>
      </div>
    );
  }
}

export default withRouter(translate()(MarketingBanner));

export { MarketingBanner };
